import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { forkJoin, from, lastValueFrom, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigsService } from './configs.service';
declare var window: any;

@Injectable({
    providedIn: 'root'
})
export class AppInitConfigService {

    constructor(private configsService: ConfigsService) { }

    // This is the method you want to call at bootstrap
    // Important: It should return a Promise
    async init(): Promise<Object> {
        const multipleFileUploadRequests: Observable<any>[] = [];
        multipleFileUploadRequests.push(this.getConfigFromFile());
        multipleFileUploadRequests.push(this.getConfigFromAPI());

        const hybridConfig = await lastValueFrom(
            forkJoin(multipleFileUploadRequests).pipe(
                map(([fileConfig, apiConfig]: any) => {
                    let hybridConfig = fileConfig;
                    if (apiConfig && Object.keys(apiConfig).length !== 0) {
                        Object.keys(apiConfig).forEach((key) => {
                            if (apiConfig[key]) {
                                hybridConfig = { ...hybridConfig, [key]: apiConfig[key] };
                            }
                        });
                    }
                    window.config = hybridConfig;
                    return hybridConfig;
                })
            )
        );
        return hybridConfig;
    }

    getConfigFromFile(): Observable<any> {
        return from(
            fetch(`/assets/config/app-config.${environment.environment_mode}.json`).then((response) => {
                return response.json();
            })
        );
    }

    getConfigFromAPI(): Observable<any> {
        return this.configsService.getDomainConfigs(window.location.hostname).pipe(map(
            (data) => {
                return data;
            }),
            catchError(() => {
                return of({});
            }));
    }
}
